import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import { exportJPK, exportJPKFA, exportJPKPKP } from "@/requests/bookkeepping";

import { FILTER_NAMES } from "@/static/filterNames";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";

export interface BookkeepingJPKStateInterface {
  recordStampId: number | null;
  exportFilters: Array<CriterionItemRequest> | null;
  jkppkpFilters: Array<CriterionItemRequest> | null;
  jkpfaFilters: Array<CriterionItemRequest> | null;

  isLoading: boolean;
}

export const BookkeepingJPKState: BookkeepingJPKStateInterface = {
  recordStampId: null,
  exportFilters: null,
  jkppkpFilters: null,
  jkpfaFilters: null,
  isLoading: true,
};

const BookkeepingJPKModule = defineModule({
  state: BookkeepingJPKState as BookkeepingJPKStateInterface,
  namespaced: true as const,
  modules: {},
  getters: {},
  mutations: {
    setExportFilters(state, param: Array<CriterionItemRequest> | null) {
      state.exportFilters = param;
    },
    setJkpPkpFilters(state, param: Array<CriterionItemRequest> | null) {
      state.jkppkpFilters = param;
    },
    setJkpfaFilters(state, param: Array<CriterionItemRequest> | null) {
      state.jkpfaFilters = param;
    },
    setIsLoading(state, param: boolean) {
      state.isLoading = param;
    },
    setRecordStampDialog(state, param: number | null) {
      state.recordStampId = param;
    },
  },
  actions: {
    async exportJpk(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsLoading(true);
      await exportJPK(state.exportFilters, FILTER_NAMES.JPKExportStandardFilter);
      commit.setIsLoading(false);
    },
    async exportJpkPkp(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsLoading(true);
      await exportJPKPKP(state.jkppkpFilters, FILTER_NAMES.JPKExportStandardFilter);
      commit.setIsLoading(false);
    },
    async exportJpkfa(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsLoading(true);
      await exportJPKFA(state.jkpfaFilters, FILTER_NAMES.JPKExportStandardFilter);
      commit.setIsLoading(false);
    },
  },
});

export default BookkeepingJPKModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, BookkeepingJPKModule);
